/* eslint-disable no-dupe-keys */
export default {
  charging_package_settlement: {
    name: '充电包结算',
    // 属性（一般与对象内容匹配）
    prop: {
      service_provider_id: '运营商',
      ev_charging_station: '充电站',
      station_settlement: '站结算记录',
      order_trade_number: '订单编号',
      charging_finish_at: '充电结束时间',
      net_income_amount: '净收入',
      settled_amount: '结算金额',
      settled_consumed_power: '结算电量',
      settled_charge_amount: '结算电费',
      settled_service_amount: '结算服务费',
      sharing_amount: 'ECMP渠道费',
      transaction_fee_rate_amount: '交易手续费',
      created_at: '创建时间',
      settled_time_range: '结算时间范围'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    titles: {
      charging_package_settlement_info: '充电包结算信息',
      charging_package_info: '充电包信息',
      order_info: '订单信息'
    }
  }
}
